import ReactDOM from 'react-dom/client';

import { FrontierTheme, sharedMuiTheme } from '@frontierag/frontier-ui-library';
import { ThemeProvider } from '@mui/material';
import { configAppInsights } from 'config';
import 'i18n';
import 'utils/yup';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Configs
configAppInsights();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider theme={sharedMuiTheme}>
    <FrontierTheme>
      <App />
    </FrontierTheme>
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
